import { BaseModel } from '../../_base/crud';

export class PharmacyGroupDrug extends BaseModel {
  id: number;
  drug_name: string;
  drug_ndc: string;
  price: number;
  is_active: boolean;

  changeActiveStatus() {
    this.is_active = !this.is_active;
  }
}
